// Reads a JSON response body that may legitimately be empty. Endpoints with
// nothing to return (e.g. a user with no goal set) answer 204 No Content with
// an empty body; calling res.json() on that throws a SyntaxError ("JSON.parse:
// unexpected end of data"). Treat an empty body as null instead of crashing.
// Returns Promise<T> (like the native res.json()) so existing call sites keep
// their types; an empty body yields null at runtime, which the null-aware
// callers already handle.
export async function readJson<T = any>(res: Response): Promise<T> {
  const text = await res.text();
  return text ? (JSON.parse(text) as T) : (null as T);
}
